module.exports = "/images/vendor/flag-icon-css/flags/4x3/pf.svg?bab3b7a56aa5cd5f44235c47ea55f5e9";